export default __webpack_public_path__ + "static/media/Hood of the Clay.a3980b5c.jpg";